import { render, staticRenderFns } from "./RightGridEventDetail.vue?vue&type=template&id=8e0b94b4"
import script from "./RightGridEventDetail.vue?vue&type=script&lang=js"
export * from "./RightGridEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports